import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { setCompanyGameId, setLastGameId } from '../Settings'
import { useAuthToken } from '@/auth/useAuthToken'
import { dashboardClient } from '@/api'
import { FullscreenLayout } from '@/components/layouts'

export function FindWebSite() {
  const navigate = useNavigate()

  const { authDone } = useAuthToken()

  const loadSite = async () => {
    try {
      let url = window.location.pathname.split('/site/')[1]

      const { data: website } = await dashboardClient.v1.searchWebsite({
        search_string: url,
      })

      if (website.game) {
        setLastGameId(website.game.id)
        setCompanyGameId(website.game.company_id)
        navigate('/company/' + website.game.company_id + '/' + website.game.id)
      } else {
        navigate('/404')
      }
    } catch (e) {
      console.log(e)
      navigate('/404')
    }
  }

  useEffect(() => {
    if (authDone) {
      loadSite()
    }
  }, [authDone])

  return <FullscreenLayout isLoading={true} />
}
